export default {
    computed: {
        imageRules() {
            return [(value) => !value || value.size < 2000000 || this.translate('errors.imageRules')];
        },
    },
};
